module.exports = __webpack_public_path__ + "static/contact-wavy-610528b479d0c65ac29aa25f2f074d9e.png";